import React, {useCallback, useEffect} from 'react'
import Logo from '../../logo.svg'
import {useToasts} from "react-toast-notifications";
import BuildService from "../../services/BuildService";
import FileUpload from "../FileUpload";

const Header = (props) => {
  const { addToast } = useToasts();

  function onFileUploadNotification(message, appearance) {
    addToast(message, { appearance: appearance, autoDismiss: true});
  }

  const getBuildVersion = useCallback(() => {
    BuildService.getBuildVersion()
      .then(response => {
        console.log("Cloud Connect Version " + response.data)
      })
      .catch(err => {
        console.log("error retrieving build info", JSON.stringify(err))
      });
  }, [])

  useEffect(() => {
    getBuildVersion()
  }, [getBuildVersion]);

    function terminate(e) {
        e.preventDefault()
        console.log("Session terminated")
        props.onEndSession()
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01"
                    aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"/>
            </button>

            <div className="collapse navbar-collapse" id="navbarColor01">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item active">
                        <a href="/#" onClick={(e) => e.preventDefault()} className="navbar-brand">
                            <img src={Logo} width="30" height="30"
                                 className="d-inline-block align-top" alt="Logo"/>
                                 <span className={"ml-2"}>PTC Cloud Connect</span>
                        </a>
                    </li>
                  <li className="nav-item current-session">
                    <div className="remote-session">Remote Session: {props.remoteHost}</div>
                  </li>
                </ul>
              <div className="user-actions">
                <FileUpload client={props.guac} onFileUploadNotification={onFileUploadNotification}/>
                  <button id={"fullscreen-btn"} onClick={props.onFullScreen} type="button" className="btn ml-2">Full Screen</button>
              </div>
                <a href="/#" onClick={terminate} className="nav-link end-session">Terminate Session</a>
            </div>
        </nav>
    )
}

export default Header
